export const onboardingSteps = ['notification', 'download_app', 'welcome_modal', 'complete'] as const;
export const onboardingPageSteps = onboardingSteps.slice(0, 2);

export type OnboardingStep = (typeof onboardingSteps)[number];

export const isValidOnboardingStep = (step: string): step is OnboardingStep => {
  return onboardingSteps.includes(step as OnboardingStep);
};

export const getWizardStepIndex = (step: OnboardingStep) => {
  return onboardingSteps.indexOf(step);
};
